class PredictiveSearch extends SearchForm {
    constructor() {
      super();
      this.cachedResults = {};
      this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
      this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
      this.isOpen = !1;
      this.abortController = new AbortController;
      this.searchTerm = "";
      this.body = document.querySelector("body");
      this.header = document.querySelector(".shopify-section-header");
      this.headerBottom = document.querySelector(".header__bottom");
      this.promoModal = document.querySelector(".search__modal");
      this.collectionList = document.querySelector(".template-404__collections");
      this.headerInput = document.querySelector(".header__search .search__input");
      // Hier den gleichen Selektor wie im mobilen Script verwenden
      this.searchCategories = document.querySelector("[data-search-extension]");
      this.calcHeight();
      this.setupEventListeners();
    }
  
    calcHeight() {
      this.results = document.querySelector(".predictive-search__result-group");
      this.resultsTabs = document.querySelector(".predictive-search__result-tabs");
      if (this.results) {
        this.results.style.setProperty("--search-height", parseInt(this.resultsTabs.getBoundingClientRect().bottom) + "px");
      }
    }
  
    setupEventListeners() {
      this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
      this.input.addEventListener("focus", this.onFocus.bind(this));
      this.addEventListener("focusout", this.onFocusOut.bind(this));
      this.addEventListener("keyup", this.onKeyup.bind(this));
    }
  
    getQuery() {
      return this.input.value.trim();
    }
  
    onChange() {
      var e = this.getQuery();
      if (!(this.searchTerm && e.startsWith(this.searchTerm))) {
        this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
      }
      this.updateSearchForTerm(this.searchTerm, e);
      this.searchTerm = e;
      if (this.searchTerm.length) {
        this.getSearchResults(this.searchTerm);
        this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock();
      } else {
        this.close(!0);
      }
    }
  
    onFormSubmit(e) {
      if (
        this.getQuery().length &&
        !this.querySelector('[aria-selected="true"] a') &&
        !e.submitter.classList.contains("card__link")
      ) {
        // Standardverhalten
      } else {
        e.preventDefault();
      }
    }
  
    onFormReset(e) {
      super.onFormReset(e);
      if (super.shouldResetForm()) {
        this.searchTerm = "";
        this.abortController.abort();
        this.abortController = new AbortController;
        this.closeResults(!0);
      }
    }
  
    onFocus() {
      var e = this.getQuery();
      if (this.classList.contains("search-modal__form")) {
        if (this.headerBottom) {
          this.headerBottom.classList.add("header__bottom--visible");
        }
        if (this.promoModal) {
          this.promoModal.classList.remove("search__modal--hidden");
        }
        if (this.collectionList) {
          this.collectionList.classList.remove("hidden");
        }
      }
      if (e.length) {
        if (this.searchTerm !== e) {
          this.onChange();
        } else if ("true" === this.getAttribute("results")) {
          this.open();
          if (this.promoModal) {
            this.promoModal.classList.add("search__modal--hidden");
          }
          if (this.collectionList) {
            this.collectionList.classList.add("hidden");
          }
        } else {
          this.getSearchResults(this.searchTerm);
        }
      }
    }
  
    onFocusOut() {
      if (this.classList.contains("search-modal__form") && this.headerBottom) {
        this.headerBottom.classList.remove("header__bottom--visible");
      }
      if (!this.classList.contains("search-modal__form")) {
        setTimeout(() => {
          if (!this.contains(document.activeElement)) {
            this.close(!0);
          }
        });
      }
    }
  
    onBlur() {
      this.headerInput.blur();
    }
  
    onKeyup(e) {
      this.getQuery().length || this.close(!0);
      e.preventDefault();
      switch (e.code) {
        case "Enter":
          e.preventDefault();
          this.selectOption();
          break;
        case "Escape":
          this.close(!0);
          this.closeResults(clearSearchTerm);
          this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock();
          break;
      }
    }
  
    updateSearchForTerm(e, t) {
      var s = this.querySelector("[data-predictive-search-search-for-text]");
      var i = s?.innerText;
      if (i) {
        if (1 < i.matchAll(new RegExp(e, "g")).length) return;
        i = i.replace(e, t);
        s.innerText = i;
      }
      this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock();
    }
  
    selectOption() {
      var e = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
      e && e.click();
    }
  
    getSearchResults(e) {
      const s = e.replace(" ", "-").toLowerCase();
      this.setLiveRegionLoadingState();
      if (this.cachedResults[s]) {
        this.renderSearchResults(this.cachedResults[s]);
        this.clickSearchTabs();
        this.calcHeight();
      } else {
        if (this.promoModal && this.classList.contains("search-modal__form")) {
          this.promoModal.classList.add("search__modal--hidden");
        }
        if (this.collectionList) {
          this.collectionList.classList.add("hidden");
        }
        fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(e)}&section_id=predictive-search`, {
          signal: this.abortController.signal
        })
          .then(e => {
            if (e.ok) return e.text();
            throw (e = new Error(e.status), this.close(), e);
          })
          .then(e => {
            const t = new DOMParser()
              .parseFromString(e, "text/html")
              .querySelector("#shopify-section-predictive-search").innerHTML;
            this.allPredictiveSearchInstances.forEach(e => {
              e.cachedResults[s] = t;
            });
            this.renderSearchResults(t);
            this.clickSearchTabs();
            this.calcHeight();
            try {
              colorSwatches();
            } catch (e) {}
          })
          .catch(e => {
            if (20 !== e?.code) {
              this.close();
              throw e;
            }
          });
        this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock();
      }
    }
  
    setLiveRegionLoadingState() {
      this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
      this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
      this.setLiveRegionText(this.loadingText);
      this.setAttribute("loading", !0);
    }
  
    setLiveRegionText(e) {
      this.statusElement.setAttribute("aria-hidden", "false");
      this.statusElement.textContent = e;
      setTimeout(() => {
        this.statusElement.setAttribute("aria-hidden", "true");
      }, 1000);
    }
  
    renderSearchResults(e) {
      this.predictiveSearchResults.innerHTML = e;
      this.setAttribute("results", !0);
      this.setLiveRegionResults();
      this.open();
      if (this.promoModal && this.classList.contains("search-modal__form")) {
        this.promoModal.classList.add("search__modal--hidden");
      }
      if (this.collectionList) {
        this.collectionList.classList.add("hidden");
      }
    }
  
    clickSearchTabs() {
      const i = this.querySelectorAll(".predictive-search__results-list");
      if (0 != i.length) {
        i[0].classList.add("active");
        this.querySelector(".predictive-search__result-tab").classList.add("active");
        this.querySelectorAll(".predictive-search__result-tab").forEach(s => {
          s.addEventListener("click", e => {
            e.preventDefault();
            const t = s.dataset.typeTarget;
            this.querySelectorAll(".predictive-search__result-tab").forEach(e => {
              e.classList.remove("active");
            });
            s.classList.add("active");
            i.forEach(e => {
              e.dataset.type == t ? e.classList.add("active") : e.classList.remove("active");
            });
          });
        });
      }
    }
  
    hidePromoBlock() {
      if (this.classList.contains("search-modal__form")) {
        if (this.promoModal) {
          this.promoModal.classList.add("search__modal--hidden");
        }
        if (this.collectionList) {
          this.collectionList.classList.add("hidden");
        }
      }
    }
  
    showPromoBlock() {
      if (this.classList.contains("search-modal__form")) {
        if (this.promoModal) {
          this.promoModal.classList.remove("search__modal--hidden");
        }
        if (this.collectionList) {
          this.collectionList.classList.remove("hidden");
        }
      }
    }
  
    setLiveRegionResults() {
      this.removeAttribute("loading");
      this.setLiveRegionText(
        this.querySelector("[data-predictive-search-live-region-count-value]").textContent
      );
    }
  
    open() {
      this.setAttribute("open", !0);
      this.input.setAttribute("aria-expanded", !0);
      this.isOpen = !0;
      this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock();
      // Statt inline Styles wird hier die "active"-Klasse entfernt,
      // damit das mobile Script konsistent bleibt.
      if (this.searchCategories) {
        this.searchCategories.classList.remove("active");
      }
    }
  
    close(e = !1) {
      this.closeResults(e);
      this.isOpen = !1;
    }
  
    closeResults(e = !1) {
      if (e) {
        this.input.value = "";
        this.removeAttribute("results");
      }
      let selected = this.querySelector('[aria-selected="true"]');
      selected && selected.setAttribute("aria-selected", !1);
      this.input.setAttribute("aria-activedescendant", "");
      this.removeAttribute("loading");
      this.removeAttribute("open");
      this.input.setAttribute("aria-expanded", !1);
      this.predictiveSearchResults.removeAttribute("style");
      this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock();
      // Hier wird die "active"-Klasse wieder hinzugefügt, sodass das mobile Script
      // die Kategorien korrekt anzeigt.
      if (this.searchCategories) {
        this.searchCategories.classList.add("active");
      }
    }
  }
  
  customElements.define("predictive-search", PredictiveSearch);